import * as React from 'react'
import { useSelector } from 'react-redux'
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useRouteMatch,
    useParams, useHistory
} from 'react-router-dom'
import { css } from 'glamor'
import {  AxiosInstance } from '../../utils/RequestMethods'
import config from '../../constants/config'
import iconsMarkers from '../../constants/iconsMarkers'
import images from '../../constants/images'
import MapBoxView from '../../components/MapBoxView'
import { ClientT, UserT } from '../../types/Users'
import Pagination from "react-js-pagination";
import { Button, Container, Spinner } from 'react-bootstrap'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import TableBootstrap from '../../components/TableBootstrap/TableBootstrap'
import { TdLink } from '../../components/TableBootstrap/TdLink'
import { IAppState } from '../../redux/reducers'
import { phoneFormat } from '../../utils'
import GoogleMapView from '../../components/MapView/GoogleMapView'


const initialCoords = {
    latitude: Number(config.coords.lat),
    longitude: Number(config.coords.long)
}

const styleRowClient = css({
    position: "relative",
    display: 'grid',
    gridGap: 2,
    gridTemplateColumns: "1fr 1fr 1fr",
    ":hover": {
        "backgroundColor": " #FED8B1",
        "cursor": "pointer",
    }
})

export interface IClientsScreenProps {

}

const ConfigPagination = {
    PerPage: 50,
    pageRangeDisplayed: 10
}


const ClientsPage: React.FC<IClientsScreenProps> = ({ }) => {
    let match = useRouteMatch();
    let { page } = useParams();

    const auth = useSelector((state: IAppState) => state.auth)
    const history = useHistory()
    const [markers, setMarkers] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    let [coords, setCoords] = React.useState(initialCoords)
    const [clients, setClients] = React.useState([])
    const [isReady, setIsReady] = React.useState(false);

    const [paginationInfo, setPaginationInfo] = React.useState({
        activePage: 1,
        itemsCountPerPage: ConfigPagination.PerPage,
        totalPages: 0,
        pageRangeDisplayed: ConfigPagination.pageRangeDisplayed,
        total: 0,

    })

    React.useEffect(() => {

        let activePage = page ? page : 1

        setPaginationInfo({
            ...paginationInfo, ...{
                activePage: activePage
            }
        })

        getClientFromDB("", activePage)
    }, [page])


    React.useEffect((): void => {
        if (auth.userData.addressDetails) {
            setCoords({
                latitude: Number(auth.userData.addressDetails.latitude),
                longitude: Number(auth.userData.addressDetails.longitude)
            })
        }

    }, [auth.userData.addressDetails])
    const goToClient = (client: ClientT): void => {
        history.push({
            pathname: `/client/${client.id}`
        })
    }
    /**
        *
        * @param page
        */
    const goToPage = (page) => {
        history.push({
            pathname: `${getBaseUrl(match)}/${page}`
        })
    }

    /**
     *
     * @param match
     */
    const getBaseUrl = (match) => {
        let url = match.url
        return url.replace(/\/[0-9]+$/g, '');
    }
    /**
      *
      * @param client
      */
    const generateBaseUrl = (client: ClientT) => {
        return `/client/${client.id}`
    }

    const getClientFromDB = async (searchStr: string = "", page: number = null): Promise<void> => {
        setLoading(true)

        try {
            let params = {
                search: searchStr,
                page: page,
                per_page: ConfigPagination.PerPage,
            }
            let options={
              data:params
            }
            AxiosInstance.get(config.url.clients,options).then(res => {
                // console.log("res", res)
                setLoading(false)
                setIsReady(true)
                if (res && res.headers && res.headers['x-wp-totalpages']) {

                    const total = res.headers['x-wp-total']
                    const totalPages = res.headers['x-wp-totalpages']
                    setPaginationInfo((draft) => {
                        draft.total = total
                        draft.totalPages = totalPages
                        draft.activePage = page
                        return draft
                    })

                }

                if (res && res.data) {
                    // @ts-ignore
                    setClients([...res.data])
                    updateMarkers(res.data)

                }
            })
        } catch (error) {
            console.log('getClientFromDB', error)
            // return []
            setIsReady(true)
            setLoading(false)
        }
    }


    const updateMarkers = (newClients: Array<ClientT>): void => {
        const markersColors = iconsMarkers.users.colors
        let markersArr = []
        newClients.map((item: ClientT, index) => {
            if (item.addressDetails) {
                let imageBg = markersColors['client'] ? markersColors['client'] : markersColors["laborer"]
                let marker = {
                    coordinate: {
                        latitude: Number(item.addressDetails.latitude),
                        longitude: Number(item.addressDetails.longitude),
                    },
                    bgImage: imageBg,
                    pinImage: images["worker-white"],
                    id: index,
                }
                markersArr.push(marker)
            }
        })
        setMarkers(markersArr)
    }

    const renderClients = (): Array<JSX.Element> => {
        return clients.map((client: ClientT, index) => {
            return (
                <div className={`${styleRowClient}`} key={index} onClick={() => { goToClient(client) }}>
                    <span>
                        <p>{client.firstName} {client.lastName}</p>
                    </span>
                    <span>
                        <p>{client.phone}</p>
                    </span>
                    <span>
                        <p>{client.email}</p>
                    </span>
                </div>
            )
        })
    }

    /**
     *
     * @returns
     */
    const renderSectionPagination = (): JSX.Element => {
        return (
            <div className="d-flex flex-row">
                <div className=" p-2 ">
                    <Pagination
                        hideFirstLastPages={true}
                        firstPageText="First"
                        lastPageText="Last"

                        prevPageText="&lt; Prev"

                        nextPageText="Next &gt;"
                        linkClass="page-link"
                        itemClass="page-item"
                        activePage={Number(paginationInfo.activePage)}
                        itemsCountPerPage={paginationInfo.itemsCountPerPage}
                        totalItemsCount={Number(paginationInfo.total)}
                        pageRangeDisplayed={paginationInfo.pageRangeDisplayed}
                        onChange={(page) => {
                            goToPage(page)
                        }}
                        getPageUrl={(i) => {
                            return `${getBaseUrl(match)}/${i}`
                        }}
                    />

                </div>
                <div>


                </div>
            </div>
        )
    }

    return (
        <Container fluid className="mt-2 mb-5">
            <div style={{ position: "relative" }} className="p-1 pr-3">
                <GoogleMapView
                   
                    coordinate={coords}
                    markers={markers} />
            </div>


            {renderSectionPagination()}

            <LoadingSpinner loading={loading}>
                <TableBootstrap<ClientT>
                    columns={['Name', 'Phone', 'Email']}
                    data={clients}
                    // customRenderColumn={customRenderColumn}
                    onClickItem={(item) => {
                        goToClient(item)
                    }}

                    renderRowItem={(item, index) => {
                        const to = generateBaseUrl(item)

                        return (
                            <>
                                <TdLink to={`${to}`}> {item.firstName} {item.lastName} </TdLink>
                                <TdLink to={`${to}`}> {phoneFormat(item.phone)} </TdLink>
                                <TdLink to={`${to}`}> {item.email}  </TdLink>
                                {/* <TdLink to={to}>{job.scheduledDate}</TdLink> */}
                            </>
                        )
                    }} />
            </LoadingSpinner>
            {renderSectionPagination()}

        </Container>
    );
}

const ClientsScreen: React.FC<{}> = ({ }) => {
    let match = useRouteMatch();
    return (
        <Switch>
            <Route path={`${match.path}/:page`}>
                <ClientsPage />
            </Route>
            <Route path={match.path}>
                <ClientsPage />
            </Route>
        </Switch>
    )
}
export default ClientsScreen;
export { ClientsScreen };
